module.exports = __webpack_public_path__ + "1aac1dbb9249fc08def7c4bb8caf9e9a.svg";